import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ourclientobj from "./OurClientObject";
import { Link } from 'react-router-dom';
const settings3 = {
  // dots: true,
  nav: true,
  infinite: true,
  autoplay: false,
  autoplaySpeed: 2000,
  speed: 500,
  slidesToShow: 5,
  lazyLoad: true,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};
const OurClient = () => {
  const JavascriptVoid = (event) => {
    event.preventDefault();
  };
  return (
    <div>
      <section className="ready-to-talk">
        <div className="container">
          <div className="section-title">
            <h2 className="text-white fontkumbh">Customer Success Stories</h2>
            <div className="bar" />
          </div>
        </div>
        <div className="partner-area partner-section">
          <div className="container">
            <div className="partner-inner">
              <div className="slider clients-carousel">
                <Slider {...settings3}>
                  {ourclientobj.map((clientobj) => {
                    return <div className="head-card" key={clientobj.id}>
                      <div className="top-client my-2">
                        <Link to={clientobj.link1} target='_blank'>
                          <img src={clientobj.img1} alt="partner" loading="lazy" />
                          {/* <img src={clientobj.img2} alt="partner" loading="lazy" /> */}
                        </Link>
                      </div>
                      <div className="top-client my-2">
                        <Link to={clientobj.link2} onClick={JavascriptVoid} target='_blank'>
                          <img src={clientobj.img3} alt="partner" loading="lazy" />
                          {/* <img src={clientobj.img4} alt="partner" loading="lazy" /> */}
                        </Link>
                      </div>
                      <div className="top-client my-2">
                        <Link to={clientobj.link3} onClick={JavascriptVoid} target='_blank'>
                          <img  src={clientobj.img5} alt="partner" loading="lazy" />
                          {/* <img src={clientobj.img6} alt="partner" loading="lazy" /> */}
                        </Link>
                      </div>
                    </div>
                  })}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  )
}

export default OurClient